import { Button, Flex, Heading } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import logo from '../assets/images/Snap-Fire-Collars-Logo.png'
import { clearAdminAuth } from '../auth/auth.support'

interface HeaderProps {
  title?: string
}

export const Header = ({ title = 'Admin' }: HeaderProps): JSX.Element => {
  const navigate = useNavigate()

  const handleLogout = (): void => {
    clearAdminAuth()
    navigate('/login', { replace: true })
  }

  return (
    <Flex
      p="8"
      align="center"
      justifyContent="space-between"
      bg={'gray.50'}
      bgImage={logo}
      bgRepeat="no-repeat"
      bgSize="100px"
      bgPos="32px 50%"
      w="100%"
    >
      <Flex w="100px" />
      <Heading size="md" color="primary" textAlign="center">
        {title}
      </Heading>
      <Button
        size="sm"
        variant="outline"
        colorScheme="red"
        onClick={handleLogout}
        w="100px"
      >
        Sign out
      </Button>
    </Flex>
  )
}
